import { Redirect, useParams } from "react-router-dom";

import SpecialLinks from "./SpecialLinks";
import Configuration from "./Configuration";
import Integrations from "./Integrations";
import CallDetection from "./CallDetection";
import CompanyUser from "./CompanyUser";
import TipGroups from "./TipGroups";
import TeamsGallery from "./TeamsGallery";

const Settings = () => {
  const { tab } = useParams();

  if (!tab || tab === "special-links") {
    return <SpecialLinks />;
  }
  if (tab === "user-metadata") {
    return <Redirect to="/user-metadata" />;
  }

  if (tab === "cid-configurations") {
    return <Configuration />;
  }

  if (tab === "integrations") {
    return <Integrations />;
  }

  if (tab === "calldetection-configuration") {
    return <CallDetection />;
  }

  if (tab === "companyuser-configuration") {
    return <CompanyUser />;
  }
  if (tab === "tip-groups-for-analytics") {
    return <TipGroups />;
  }
  if (tab === "teams-gallery") {
    return <TeamsGallery />;
  }

  return null;
};

export default Settings;
